// Dynamic imports
const OrganizationList = () => import('@/views/organizations/OrganizationList.vue')
const OrganizationView = () => import('@/views/organizations/OrganizationView.vue')
const OrganizationForm = () => import('@/views/organizations/OrganizationForm.vue')
const OrganizationDetails = () => import('@/views/organizations/OrganizationDetails.vue')
const LocationsList = () => import('@/views/locations/LocationsList.vue')
const LocationForm = () => import('@/views/locations/LocationForm.vue')
const LocationView = () => import('@/views/locations/LocationView.vue')
const FaqList = () => import('@/views/faqs/FaqList.vue')
const FaqForm = () => import('@/views/faqs/FaqForm.vue')
const FaqView = () => import('@/views/faqs/FaqView.vue')

export const organizationRoutes = [
  {
    path: '/organizations',
    name: 'Organizations',
    component: OrganizationList,
    meta: {
      requiresAuth: true,
      title: 'Organizations'
    }
  },
  {
    path: '/organizations/new',
    name: 'NewOrganization',
    component: OrganizationForm,
    meta: {
      requiresAuth: true,
      title: 'New Organization'
    }
  },
  {
    path: '/organizations/:id',
    component: OrganizationView,
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: '',
        name: 'OrganizationView',
        component: OrganizationDetails,
        meta: {
          title: 'View Organization'
        }
      },
      {
        path: 'edit',
        name: 'EditOrganization',
        component: OrganizationForm,
        meta: {
          requireAuth: true,
          title: 'Edit Organization'
        }
      },
      {
        path: 'locations',
        name: 'OrganizationLocations',
        component: LocationsList,
        meta: {
          requireAuth: true,
          title: 'Organization Locations'
        }
      },
      {
        path: 'locations/new',
        name: 'NewLocation',
        component: LocationForm,
        meta: {
          requireAuth: true,
          title: 'New Location'
        }
      },
      {
        path: 'locations/:locationId',
        name: 'ViewLocation',
        component: LocationView,
        meta: {
          requireAuth: true,
          title: 'View Location'
        }
      },
      {
        path: 'locations/:locationId/edit',
        name: 'EditLocation',
        component: LocationForm,
        meta: {
          requireAuth: true,
          title: 'Edit Location'
        }
      },
      {
        path: 'phone-numbers',
        name: 'OrganizationPhoneNumbers',
        component: () => import('@/views/organizations/OrganizationPhoneNumbers.vue'),
        meta: {
          requireAuth: true,
          title: 'Organization Phone Numbers'
        }
      },
      {
        path: 'faqs',
        name: 'OrganizationFaqs',
        component: FaqList,
        meta: {
          requireAuth: true,
          title: 'Organization FAQs'
        }
      },
      {
        path: 'faqs/new',
        name: 'NewFaq',
        component: FaqForm,
        meta: {
          requireAuth: true,
          title: 'New FAQ'
        }
      },
      {
        path: 'faqs/:faqId',
        name: 'ViewFaq',
        component: FaqView,
        meta: {
          requireAuth: true,
          title: 'View FAQ'
        }
      },
      {
        path: 'faqs/:faqId/edit',
        name: 'EditFaq',
        component: FaqForm,
        meta: {
          requireAuth: true,
          title: 'Edit FAQ'
        }
      }
    ]
  }
]
